import { format } from "date-fns";

/**
 * Formats a timestamp to a date string "HH:mm:ss"
 */
export const formatDateToTimeOnly = (timestamp: string): string => {
  const date = new Date(timestamp);
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "";
  }
  return format(date, "HH:mm:ss");
};

/**
 * Formats a timestamp to a date string "dd.MM.yyyy HH:mm:ss" or returns the default value
 * if the timestamp is undefined.
 *
 * @param timestamp The timestamp to format
 * @param options The options for the formatting
 * @param options.default The default value to return if the timestamp is undefined
 */
export const formatDate = (
  timestamp: Date | string | null | undefined,
  options?: {
    default: string;
  },
): string => {
  if (timestamp === undefined || timestamp === null) {
    return options?.default ?? "-";
  }

  return format(new Date(timestamp), "dd.MM.yyyy HH:mm:ss");
};

/**
 * Formats a Date object to a date only string "yyyy-MM-dd".
 * Returns null if the input is null or undefined.
 *
 * @param date The Date object to format
 * @returns A string in "yyyy-MM-dd" format or null
 */
export const formatDateOnly = (
  date: Date | null | undefined,
): string | null => {
  if (date === null || date === undefined) {
    return null;
  }

  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return null;
  }

  return format(date, "yyyy-MM-dd");
};
